import React, { useContext } from 'react'

import { userContext } from 'global/context/sub-contexts/userContext'
import './FacebookCommentsSection.scss'

const FacebookCommentsSection = ({ question, url = null }) => {
  const user_context = useContext(userContext)
  const { isLoggedInBoolean, isGuest } = user_context || {}

  let brkURL = typeof window !== 'undefined' ? window.location.href : ''
  if (url) {
    brkURL = url
  }

  return (
    isLoggedInBoolean &&
    !isGuest && (
      <div className={`facebook-comments-container`}>
        <div className={`main`}>
          {question && <h2>{question}</h2>}
          <div
            className={'fb-comments'}
            data-href={brkURL}
            data-width="100%"
          ></div>
        </div>
      </div>
    )
  )
}

export default FacebookCommentsSection
